import React from 'react'

/**
 * Registry of lazy-loaded tool renderer components.
 * Each tool ID maps to a React component that renders the tool's interactive form.
 */
export const toolRenderers: Record<string, React.LazyExoticComponent<React.ComponentType<{ toolId: string }>>> = {
  // Personal Development & Purpose
  'strengths-workons': React.lazy(() => import('./StrengthsWorkons')),
  'player-captain-coach': React.lazy(() => import('./PlayerCaptainCoach')),
  'my-next-chapter': React.lazy(() => import('./MyNextChapter')),
  // Well-being & Self-care
  'resilience-audit': React.lazy(() => import('./ResilienceAudit')),
  'drivers-belonging': React.lazy(() => import('./DriversBelonging')),
  'energy-givers-sappers': React.lazy(() => import('./EnergyGiversSappers')),
  'psychological-safety': React.lazy(() => import('./PsychologicalSafety')),
  // Prioritisation
  'abcd': React.lazy(() => import('./ABCD')),
  'perform-transform': React.lazy(() => import('./PerformTransform')),
  'goals-barriers': React.lazy(() => import('./GoalsBarriers')),
  'ai-matrix': React.lazy(() => import('./AIMatrix')),
  // Strategy
  'mission-strategy-tactics': React.lazy(() => import('./MissionStrategyTactics')),
  'nasard': React.lazy(() => import('./NASARDDifferentiators')),
  'reduce-simplify': React.lazy(() => import('./ReduceSimplify')),
  // Feedback
  'know-about-me': React.lazy(() => import('./KnowAboutMe')),
  'relationship-resets': React.lazy(() => import('./RelationshipResets')),
  // Codifying & Contracting
  'teamship-charter': React.lazy(() => import('./TeamshipCharter')),
  'one-on-one': React.lazy(() => import('./OneOnOne')),
  'teamship-contract': React.lazy(() => import('./TeamshipContract')),
  'start-stop-double': React.lazy(() => import('./StartStopDouble')),
  'inter-team-contracting': React.lazy(() => import('./InterTeamContracting')),
  // Reviewing & Resetting
  'teamship-audit': React.lazy(() => import('./TeamshipAudit')),
  'exco-audit': React.lazy(() => import('./ExCoAudit')),
  'hot-debrief': React.lazy(() => import('./HotDebrief')),
  // Meetings & Infrastructure
  'forums-upgrade': React.lazy(() => import('./ForumsUpgrade')),
  'meeting-pyramid': React.lazy(() => import('./MeetingPyramid')),
  // Innovation & Decision-making
  'four-q': React.lazy(() => import('./FourQ')),
  'brainstrust': React.lazy(() => import('./BrainsTrust')),
  // Getting to Know Each Other
  'backstories': React.lazy(() => import('./Backstories')),
  'boom': React.lazy(() => import('./Boom')),
  'fifty-questions': React.lazy(() => import('./FiftyQuestions')),
  'dev-accelerator': React.lazy(() => import('./DevAccelerator')),
}
